import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import ISalesProduct from "@/interfaces/sales-product.interfaces";
import salesProductService from "@/services/sales-product.service";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetSalesProductReturn = RequestsBaseReturn<PaginatedResponse<ISalesProduct> | null>;

export type Props = RequestPagination & {
  filters: IFilter<ISalesProduct>[];
};

type GetSalesProductSwrParams = [string, number, number, IFilter<ISalesProduct>[]];

const useGetSalesProduct = ({ pageNumber, pageSize, filters }: Props): UseGetSalesProductReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<ISalesProduct>, Error, GetSalesProductSwrParams>(
    [SWR_KEYS.getSalesProduct, pageNumber, pageSize, filters],
    ([, _pageNumber, _pageSize, _filters]) =>
      salesProductService.getAllSalesProducts(_filters, {
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetSalesProduct;
